module.exports = __webpack_public_path__ + "static/img/customWx.661ea066.jpg";